import { useState} from 'react';

export default function useToken() {
    // get token from session storage and return token, return null if not token
    const getToken = () => {
        const tokenString = localStorage.getItem('userId');
        const userToken = JSON.parse(tokenString);
        return userToken?userToken:null;
    };

    const [token, setToken] = useState(getToken());

    const saveToken = userToken => {
        localStorage.setItem('userId', JSON.stringify(userToken));
        setToken(userToken);
    };

    return {
        setToken: saveToken,
        token
    }
}